import { FC } from 'react'
import * as Styled from './styles'
import optimizedResumeVersionsImage from './images/optimized-resume-versions.png'

export const OptimizedResumePreview: FC = () => {
  return <Styled.Image src={optimizedResumeVersionsImage} alt="Optimized resume versions" />
}
